import { useAtomValue, useSetAtom } from 'jotai';
import { RESET } from 'jotai/utils';
import { loggerAtom } from '../../logger/logger-atom';
import { drawerAtom } from '../atoms/drawer.atom';
export const TASK_QUESTION_PROPS = {
  title: () => 'Task Questionnaire',
  description: ''
};
type Props = {
  taskQuestionnaireComponent: {
    Component: ({
      onClose
    }: {
      onClose?: (() => void) | undefined;
    }) => React.ReactNode;
    status: 'PENDING' | 'DONE' | 'OPTIONAL';
  } | undefined;
};
export const useTaskQuestionnaire = ({
  taskQuestionnaireComponent
}: Props) => {
  const logger = useAtomValue(loggerAtom);
  const setDrawer = useSetAtom(drawerAtom);
  const closeTaskQuestionnaire = () => {
    setDrawer(RESET);
  };
  const openTaskQuestionnaire = () => {
    if (!taskQuestionnaireComponent) {
      logger?.error('Task questionnaire panel cannot be rendered if the component is undefined');
      return;
    }
    setDrawer({
      ...TASK_QUESTION_PROPS,
      onClose: closeTaskQuestionnaire,
      component: ({
        onClose
      }) => taskQuestionnaireComponent.Component?.({
        onClose
      }),
      isOpen: true
    });
  };
  return {
    closeTaskQuestionnaire,
    openTaskQuestionnaire
  };
};